module.exports = __webpack_public_path__ + "img/case5-华东理工.6232fb10.png";